import icon from '../../../../includes/primitives/icons'
export default {
  data: () => ({

    icon: icon.arrow,

    rawData:  [],
    
    circle: null,
    title: null,
    summary: null,
    columns: null,
    keys: null,
    filters: null,
    
    drawY: 0,
    angle: {},
    canvasForms:  null,
  }),

  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },

  methods: {
    set_ColorStyles() {
      this.gmx_ColorV2Sets()
    },
  }

}